import {
  HRIS_IMPORT_LOG_STATUSES,
  HrisImportLogStatus,
} from '../../typescript-types/hris-import-log';

import { humanize } from '../../util/formatters';

export const createDisplayStatus = (
  importStatus: HrisImportLogStatus | null,
  user: AuthenticatedUser,
) => {
  if (!importStatus) {
    return 'In Progress';
  }

  const humanizedStatus = humanize(importStatus);
  // The merge_fail status does not make sense to show to our users
  // because we are the layer between them and Merge. This information
  // will only be useful and make sense to TE admins
  if (importStatus === HRIS_IMPORT_LOG_STATUSES.MERGE_FAIL) {
    return user.isAdmin ? humanizedStatus : 'Fail';
  }
  return humanizedStatus;
};
